import { defineStore } from 'pinia'
import { logFetchWarning } from '~/utils/fetchErrorLog'

interface CurrencyUpdatePayload {
  payload: Currency[]
  main?: Currency
}

export const useCurrencyStore = defineStore('currency', () => {
  const currencies = ref<Currency[]>([])
  const main = ref<Currency>({
    _id: '',
    name: '',
    symbol: '฿',
  })
  const currentSymbol = ref<SupportedSymbol | undefined>()
  const currentName = ref('')

  const { $api } = useNuxtApp()

  /**
   * Fetch available currencies from API
   */
  const fetch = async () => {
    try {
      const response = await $api<ApiSuccessResponse<Currency[]>>('/currencies')
      const data = response.data

      if (data) {
        update({ payload: data })
      }
    } catch (error) {
      logFetchWarning('Failed to fetch currencies', error)
      throw error
    }
  }

  /**
   * Update currency store with new data
   */
  const update = ({ payload }: CurrencyUpdatePayload) => {
    currencies.value = payload
  }

  const setCurrentSymbol = (symbol: SupportedSymbol | undefined) => {
    currentSymbol.value = symbol
    currentName.value = currencies.value.find((currency: Currency) => currency.symbol === symbol)?.name || ''
  }

  return {
    currencies,
    main,
    currentSymbol,
    currentName,
    fetch,
    update,
    setCurrentSymbol,
  }
})
